module.exports = __webpack_public_path__ + "img/brokenheart_ios_802.png";